import {AGENCY_FLEX_INDICATOR, FLEX_INDICATOR_COLUMN_TO_DATA} from "../columns";

// Mapa de filas FIXED → metric_name del backend (mismo que en panels.jsx), para poder fusionar
// una comparativa flex (metricName="Conversions") con su métrica fija ("CONVERSIONS").
const FIXED_ROW_METRIC_NAME = {
    COST: 'Cost', CLICKS: 'Clicks', IMPRESSIONS: 'Impressions', CPC: 'CPC', CTR: 'CTR', CPM: 'CPM',
    CONVERSIONS: 'Conversions', CPA: 'CPA', PURCHASES_VALUE: 'Purchase Value', ROAS: 'ROAS', ACOS: 'ACOS',
};

// Una chip es "comparativa" si es un flex indicator con vsPeriod ≠ NO_COMPARATION.
function chipIsComparative(chip) {
    if (!chip || typeof chip.columnId !== 'string' || !chip.columnId.includes(AGENCY_FLEX_INDICATOR)) return false;
    const parts = FLEX_INDICATOR_COLUMN_TO_DATA(chip.columnId);
    return !!(parts && parts.vsPeriod && parts.vsPeriod !== 'NO_COMPARATION');
}

// Clave canónica de métrica de una fila (para agrupar todas sus variantes en una sola).
function metricKey(row) {
    if (row.metricName) return 'M:' + row.metricName;
    if (FIXED_ROW_METRIC_NAME[row.id]) return 'M:' + FIXED_ROW_METRIC_NAME[row.id];
    return null;  // sin clave → no se fusiona (objetivos, presupuesto, saldos, atributos…)
}

// Fusiona en UNA fila todas las variantes de una misma métrica: períodos fijos/auto + comparativas
// de la agencia. Antes aparecían como filas separadas (la métrica + la comparativa suelta). Las chips
// comparativas quedan marcadas (isComparative, para el ✨) y se ordenan al final.
export function mergeMetricRows(rows) {
    const byKey = {};
    const result = [];

    rows.forEach((row) => {
        const key = metricKey(row);
        if (!key) {
            result.push(row);
            return;
        }
        if (!byKey[key]) {
            const clone = {
                ...row,
                isFlex: false,  // el ✨ pasa a las chips comparativas, no a la fila entera
                chips: row.chips.map((c) => ({...c, isComparative: chipIsComparative(c)})),
            };
            byKey[key] = clone;
            result.push(clone);
        } else {
            const base = byKey[key];
            const seen = new Set(base.chips.map((c) => c.columnId));
            row.chips.forEach((c) => {
                if (seen.has(c.columnId)) return;
                seen.add(c.columnId);
                base.chips.push({...c, isComparative: chipIsComparative(c)});
            });
        }
    });

    // Períodos estándar primero, comparativas al final (que la comparativa sea la "última opción").
    result.forEach((row) => {
        if (row.chips && row.chips.some((c) => c.isComparative)) {
            row.chips = [
                ...row.chips.filter((c) => !c.isComparative),
                ...row.chips.filter((c) => c.isComparative),
            ];
        }
    });

    return result;
}
